import { DEFAULTS, validatePreferences, type Preferences } from './preferences';
import { ranked, validateHighScore, type HighScore } from './highscores';
export interface SaveData { version:2; preferences:Preferences; scores:HighScore[] }
export interface StorageLike { getItem(key:string):string|null; setItem(key:string,value:string):void }
export const STORAGE_KEY='frogger81.save';
export class Database {
  data:SaveData={version:2,preferences:{...DEFAULTS},scores:[]};
  warning=false;
  private readOnly=false;
  constructor(private storage:StorageLike|null){this.load();}
  private load():void{
    try{
      const raw=this.storage?.getItem(STORAGE_KEY);if(!raw)return;
      const value=JSON.parse(raw) as {version?:number;preferences?:unknown;scores?:unknown[];highscores?:unknown[]};
      // Future versions remain untouched, rather than silently being overwritten.
      if((value.version||1)>2){this.warning=true;this.readOnly=true;return;}
      const scores=(Array.isArray(value.scores)?value.scores:Array.isArray(value.highscores)?value.highscores:[])
        .map(validateHighScore).filter((v):v is HighScore=>v!==null);
      this.data={version:2,preferences:validatePreferences(value.preferences),scores:ranked(scores)};
    }catch{this.warning=true;}
  }
  get highScore():number{return Math.max(0,...this.data.scores.map(s=>s.score));}
  savePreferences(preferences:Preferences):void{this.data.preferences=validatePreferences(preferences);this.persist();}
  addScore(score:HighScore):void{const v=validateHighScore(score);if(v){this.data.scores=ranked([...this.data.scores,v]);this.persist();}}
  qualifies(score:number):boolean{return score>0&&(this.data.scores.length<10||score>this.data.scores.at(-1)!.score);}
  private persist():void{
    if(this.readOnly)return;
    try{if(!this.storage)throw new Error('No storage');this.storage.setItem(STORAGE_KEY,JSON.stringify(this.data));this.warning=false;}
    catch{this.warning=true;}
  }
}
export function browserDatabase():Database{try{return new Database(window.localStorage);}catch{return new Database(null);}}
